import React from 'react';

const Bell = ({size, color}) => (
	<svg height={size} width={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<g fill={color} stroke={color} strokeLinecap="square" strokeWidth={2}>
			<path d="M19,13V8A7,7,0,0,0,5,8v5a13.834,13.834,0,0,1-2,7H21A13.834,13.834,0,0,1,19,13Z" fill="none" stroke={color}/>
			<path d="M9.174,22a3,3,0,0,0,5.652,0Z" stroke="none"/>
		</g>
	</svg>
);

export default Bell;